import React from 'react'
import { connect } from 'react-redux'
import { TextField } from 'redux-form-material-ui'
import { Field } from 'redux-form'

const styles = {
  imageWrapper: {
    textAlign: 'center',
    fontWeight: 'bold',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '200px',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
  },
}

class RecognitionPage extends React.Component {

  required = value => value == null ? 'Requerido' : undefined

  render() {
    const { mission_page } = this.props
    return (
      <div >
        <div style={styles.imageWrapper}>
          <img style={styles.image} src={mission_page.user.image_url} alt={`${mission_page.user.first_name} ${mission_page.user.last_name}`} />
          {`${mission_page.user.first_name} ${mission_page.user.last_name}`}
        </div>
        <Field
          name={`mission_page_${mission_page.id}`}
          floatingLabelText="Reconoce el logro de tu compañero..."
          component={TextField} fullWidth type="text"
          multiLine
          validate={this.required}
          rows={4}
          rowsMax={8}
        />
      </div>
    )
  }

}

RecognitionPage.propTypes = {
  mission_page: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
  }).isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(RecognitionPage)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/RecognitionPage/index.jsx